import { isAppAuthModules } from "native-sdk";
import { ICredentialsWithServer } from "../credentialsStore";
import { FeatureFlagName } from "../featureFlagName";
import { shouldUseAppAuthIamLogin } from "../auth/appAuthIamLogin";
import { IAuthFailureHandlerApi } from "./interfaces";

export function handleIamEarlyReturn(
    api: IAuthFailureHandlerApi,
    credentials: ICredentialsWithServer | null
): boolean {
    // IAM user with jwt token — only redirect if keycloak session is invalidated, not the token
    if (credentials?.credentials?.iamJwt) {
        return true;
    }
    // AppAuth IAM user without jwt/sessionId — same rule
    if (isAppAuthModules()
        && !credentials?.credentials?.iamJwt
        && !credentials?.credentials?.sessionId
        && shouldUseAppAuthIamLogin(
            api.featureFlagService?.hasFeatureFlag(FeatureFlagName.ENABLE_APP_AUTH_IAM_LOGIN_POPUP)
        )) {
        return true;
    }
    return false;
}
